import {getCancelButton} from "../../../constants/RouteDefinitions";
import {IButton, TRouteIdOrDefinition} from "../../../index";
import type {IDialogOpt} from "../../dialog/manager";
import cancelHtml from './cancel.html?raw';

export const template = cancelHtml

interface ICancelButtonParams {
    __dialog?: IDialogOpt
    idOrDefOrFn?: TRouteIdOrDefinition | Function
    config?: Partial<IButton>
}

export class viewModel {
    private readonly btn: Partial<IButton>
    constructor(params: ICancelButtonParams = {}) {
        this.btn = getCancelButton(params.idOrDefOrFn ?? params.__dialog?.close, params.config) ?? {}
    }
}
